import pt from 'prop-types';
import { isEmpty } from 'lodash/fp';
import { Component } from 'react';
import { Empty } from '@mews-commander/ui';
import { pagedTableFactory } from '@mews-commander/ui/legacy';

export default ({ mapping, AdditionalActionComponent }: $TSFixMe) => {
    const Table = pagedTableFactory(AdditionalActionComponent);

    class EntityTable extends Component {
        static propTypes = {
            // @ts-expect-error $TSFixMeError: Argument of type '<P extends ValidationMap<any>>(type: P) => Requireable<InferProps<P>>' is not assignable to parameter ...
            source: pt.arrayOf(pt.shape),
        };

        render() {
            // @ts-expect-error $TSFixMeError: Property 'source' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
            const { source, ...other } = this.props;
            return isEmpty(source) ? <Empty /> : <Table mapping={mapping} source={source} {...other} />;
        }
    }

    return EntityTable;
};
